<template>
  <li class="md-list-item">
    <router-link class="md-list-item-router md-list-item-container md-button-clean" @click="hideSidebar"
      v-bind="$attrs">
      <div class="md-list-item-content md-ripple">
        <slot>
          <md-icon>{{ link.icon }}</md-icon>
          <p>{{ link.name }}</p>
        </slot>
      </div>
    </router-link>
  </li>
</template>
<script>
export default {
  inject: {
    autoClose: {
      default: true,
    },
  },
  props: {
    link: {
      type: [String, Object],
      default: () => {
        return {
          name: "",
          path: "",
          icon: "",
        };
      },
    },
    tag: {
      type: String,
      default: "router-link",
    },
  },
  methods: {
    hideSidebar() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  logout() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("usuario");
    localStorage.removeItem("tokenExpiry");

    // Notifica a otras pestañas que deben cerrar sesión
    localStorage.setItem("logout_event", Date.now());

    this.$router.push({ name: "Login" });
  }
};
</script>
<style></style>
